export default __webpack_public_path__ + "static/media/47-min.352aaeec.jpg";